(function () {
  if (window.customElements.get('pair-tiers')) {
    return;
  }

  function formatMoney(cents, format) {
    var value = cents / 100;
    var fixed = value.toFixed(2);
    var whole = Math.round(value).toString();
    var tokens = {
      amount: fixed.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      amount_no_decimals: whole.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      amount_with_comma_separator: fixed.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
      amount_no_decimals_with_comma_separator: whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
      amount_with_apostrophe_separator: fixed.replace(/\B(?=(\d{3})+(?!\d))/g, "'")
    };

    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) {
        return tokens[key] !== undefined ? tokens[key] : match;
      });
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return tokens.amount_with_comma_separator + ' €';
  }

  class PairTiers extends HTMLElement {
    connectedCallback() {
      this.formId = this.getAttribute('form-id');
      this.group = this.getAttribute('group') || 'set';
      this.variantId = Number(this.getAttribute('variant-id'));
      this.variantPrice = Number(this.getAttribute('variant-price'));
      this.variantStock = this.hasAttribute('variant-stock') ? Number(this.getAttribute('variant-stock')) : null;
      this.variantIds = (this.getAttribute('variant-ids') || '').split(',').map(Number);
      this.moneyFormat = this.getAttribute('money-format') || '';
      this.productTitle = this.getAttribute('product-title') || '';
      this.bundleTitleTemplate = this.getAttribute('bundle-title-template') || '';

      this.count = 1;
      this.percent = 0;

      this.options = Array.prototype.slice.call(this.querySelectorAll('[data-pair-count]'));
      this.bundleInput = this.querySelector('[data-pair-bundle-id]');
      this.parentInput = this.querySelector('[data-pair-parent-id]');
      this.titleInput = this.querySelector('[data-pair-bundle-title]');
      this.quantityFallback = null;

      this.options.forEach(function (option) {
        option.addEventListener('click', function () {
          if (option.disabled) {
            return;
          }
          this._select(Number(option.dataset.pairCount), Number(option.dataset.pairPercent));
        }.bind(this));
      }, this);

      this._onVariantChange = this._handleVariantChange.bind(this);
      this._onVariantAdd = this._handleVariantAdd.bind(this);
      this._onRerender = this._handleRerender.bind(this);

      document.addEventListener('variant:change', this._onVariantChange);
      document.addEventListener('variant:add', this._onVariantAdd);

      var form = this._form();
      if (form) {
        form.addEventListener('product:rerender', this._onRerender);
      }

      this._refreshAvailability();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariantChange);
      document.removeEventListener('variant:add', this._onVariantAdd);

      var form = this._form();
      if (form) {
        form.removeEventListener('product:rerender', this._onRerender);
      }
    }

    _form() {
      return document.forms[this.formId] || null;
    }

    _handleVariantChange(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || this.variantIds.indexOf(Number(variant.id)) === -1) {
        return;
      }

      this.variantId = Number(variant.id);
      this.variantPrice = Number(variant.price);

      if (variant.inventory_management && variant.inventory_policy === 'deny' && typeof variant.inventory_quantity === 'number') {
        this.variantStock = variant.inventory_quantity;
      } else {
        this.variantStock = null;
      }

      this.parentInput.value = this.variantId;
      this._refreshAvailability();
    }

    _handleRerender() {
      window.setTimeout(function () {
        this._applyPrice();
        this._syncQuantity();
      }.bind(this), 0);
    }

    _handleVariantAdd() {
      if (this.count > 1) {
        this.bundleInput.value = this._newBundleId();
      }
    }

    _newBundleId() {
      return this.group + '-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    }

    _refreshAvailability() {
      var activeStillAvailable = true;

      this.options.forEach(function (option) {
        var count = Number(option.dataset.pairCount);
        var unavailable = this.variantStock !== null && count > this.variantStock;
        option.disabled = unavailable;
        if (unavailable && count === this.count) {
          activeStillAvailable = false;
        }
      }, this);

      if (!activeStillAvailable) {
        this._select(1, 0);
        return;
      }

      this._applyPrice();
    }

    _select(count, percent) {
      this.count = count;
      this.percent = percent;

      this.options.forEach(function (option) {
        var active = Number(option.dataset.pairCount) === count;
        option.classList.toggle('is-active', active);
        option.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (count > 1) {
        this.bundleInput.value = this._newBundleId();
        this.bundleInput.disabled = false;
        this.parentInput.value = this.variantId;
        this.parentInput.disabled = false;

        if (this.titleInput) {
          this.titleInput.value = this._bundleTitle(count);
          this.titleInput.disabled = false;
        }
      } else {
        this.bundleInput.disabled = true;
        this.parentInput.disabled = true;

        if (this.titleInput) {
          this.titleInput.disabled = true;
        }
      }

      this._syncQuantity();
      this._applyPrice();
    }

    _bundleTitle(count) {
      if (!this.bundleTitleTemplate) {
        return this.productTitle;
      }

      return this.bundleTitleTemplate
        .split('[count]').join(String(count))
        .split('[title]').join(this.productTitle)
        .trim();
    }

    _syncQuantity() {
      var form = this._form();
      if (!form) {
        return;
      }

      var input = form.elements['quantity'];
      if (input && input.length !== undefined && !input.tagName) {
        input = input[0];
      }

      if (input) {
        if ('quantity' in input) {
          input.quantity = this.count;
        }
        input.value = this.count;
        return;
      }

      if (!this.quantityFallback) {
        this.quantityFallback = document.createElement('input');
        this.quantityFallback.type = 'hidden';
        this.quantityFallback.name = 'quantity';
        this.quantityFallback.setAttribute('form', this.formId);
        this.appendChild(this.quantityFallback);
      }
      this.quantityFallback.value = this.count;
    }

    _priceList() {
      var scope = this.closest('.product-info') || document;
      return scope.querySelector('[data-block-type="price"] .price-list');
    }

    _applyPrice() {
      var priceList = this._priceList();
      if (!priceList) {
        return;
      }

      if (!priceList.dataset.pairOriginal) {
        priceList.dataset.pairOriginal = priceList.innerHTML;
      }

      if (this.count <= 1) {
        priceList.innerHTML = priceList.dataset.pairOriginal;
        return;
      }

      var total = this.variantPrice * this.count;
      var discounted = Math.round(total * (100 - this.percent) / 100);

      var html = '<sale-price class="text-lg text-on-sale">' + formatMoney(discounted, this.moneyFormat) + '</sale-price>';
      if (this.percent > 0) {
        html += '<compare-at-price class="text-subdued line-through">' + formatMoney(total, this.moneyFormat) + '</compare-at-price>';
        html += '<span class="price-chip">-' + this.percent + '%</span>';
      }

      priceList.innerHTML = html;
    }
  }

  window.customElements.define('pair-tiers', PairTiers);
})();
